import { Component, ChangeDetectionStrategy, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { PlainJaneIndexCardStackContentViewModel } from './plain-jane-index-card-stack-content-view-model';

@Component({
  selector: 'app-plain-jane-index-card-stack-content',
  templateUrl: './plain-jane-index-card-stack-content.component.html',
  styleUrls: ['./plain-jane-index-card-stack-content.component.scss'],
  providers: [PlainJaneIndexCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PlainJaneIndexCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: PlainJaneIndexCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
